module.exports = __webpack_public_path__ + "img/sign-in-icon.6b7c0f2d.svg";